import React, { Component } from 'react';
import { loginRequest } from './msal-config';

import LoginComponent from '../components/login-component';

export function WithAuth(HocComponent) {

  return class extends Component {
    constructor(props) {
      super(props);

      this.state = {
        isAuthenticated: false,
        user: {},
        accessToken: null,
        renewIframe: false,
        hasError: false,
        errorMessage: null
      };
    }

    async componentDidMount() { //NEED TO RETURN TO THIS PROMPTLY IN CASE IT STOPS WORKING HENCE PREVENTING LOGIN!!
      let userAccount = this.props.instance.getActiveAccount();
      if (!userAccount) {
        //this.props.instance.loginRedirect({});  //NB - put this back in of you want to bypass the welcome page and have to press the login button!
        return;
      } else {
        this.setState({
          isAuthenticated: true,
          user: userAccount.username
        });
      }
    }

    onSignIn() {
      this.props.instance.loginRedirect(loginRequest)
        .catch((e) => {
          console.error(e);
        });
    }

    onSignOut() {
      this.props.instance.logoutPopup(); // or logoutRedirect()
    }

    render() {
      if (this.state.isAuthenticated) {
        return <HocComponent auth={this.state} onSignIn={() => this.onSignIn()} onSignOut={() => this.onSignOut()}  {...this.props} />;

      }
      else if (!this.state.isAuthenticated) {
        return <LoginComponent login={() => this.onSignIn()} />;
      }

      if (this.state.hasError) {
        return <div>{this.state.errorMessage}</div>;
      }

      return <div>Login in progress...</div>;
    }
  };
}
